import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";
import { ProjectCard } from "../components/ProjectCard";
import { ProjectMarquee } from "../components/Marquee";
import { projects } from "../data/site";

export default function Projects() {
  return (
    <main data-testid="projects-page">
      <SEO
        title="Ongoing Projects — Parsn Group"
        description="Five MahaRERA-registered redevelopment projects across Kurla and Chembur: Parsn Bhagyalakshmi, Shiv Vaibhav, Pancharatna, Sharada and Avighna."
        path="/projects"
      />
      <section className="bg-white pt-32 sm:pt-44 pb-16 sm:pb-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="overline-label mb-4">Ongoing projects</p>
            <h1 className="font-serif text-4xl sm:text-6xl text-ink tracking-tight leading-[1.05] max-w-3xl">
              Five addresses, one standard of <span className="italic text-navy">craft.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base sm:text-lg text-gray-600 leading-relaxed">
              Active redevelopment projects across Kurla and Chembur — each MahaRERA registered,
              each built on five decades of delivery.
            </p>
          </Reveal>
        </div>
      </section>
      <ProjectMarquee />
      <section className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 items-start">
          {projects.map((p, i) => (
            <ProjectCard key={p.slug} project={p} index={i} />
          ))}
        </div>
      </section>
    </main>
  );
}
